<template>
  <div>
    <Card>
      <div class="search-con search-con-top">
        <Form :model="form" :label-width="80" inline>
          <FormItem label="银行名称">
            <Input v-model="form.name"></Input>
          </FormItem>
          <FormItem label="银行标识">
            <Input v-model="form.code"></Input>
          </FormItem>
        </Form>
        <div class="toolbar">
          <Button type="primary" icon="md-add" @click="handleCreate">新增</Button>
          <Button type="primary" icon="md-trash" @click="handleDelete">删除</Button>
          <Button @click="handleSearch" icon="md-search" class="search-btn" type="primary">搜索</Button>
        </div>
      </div>
      <Tables ref="tables" v-model="tableData" :columns="columns" @on-search="handleSearch"
              @on-update="handleUpdate" @on-detail="handleDetail" @on-selection-change="selectionChange"/>
    </Card>
    <bankinfoInfo ref="bankinfoInfoRef" @handle-search="handleSearch" ></bankinfoInfo>
  </div>
</template>

<script>
import bankinfoInfo from './bankinfo-info'
import { getIds } from '@/libs/util'

export default {
  name: 'bankinfo-list',
  components: {
    bankinfoInfo
  },
  data () {
    return {
      columns: [
        { title: '银行名称', key: 'name' },
        { title: '银行标识', key: 'code' },
        { title: '查询银行信息关键字', key: 'findKey' },
        { title: 'java的bean类', key: 'beanName' },
        { title: '电子签',
          key: 'hasSign',
          render: (h, params) => {
            return h('span', this.getDictVal('yes_no', params.row.hasSign))
          } },
        { title: '结息日', key: 'settlementDate' },
        {
          title: '操作',
          key: 'handle',
          minWidth: 200,
          options: ['update', 'detail']
        }
      ],
      tableData: {
        rows: [],
        total: 0
      },
      form: {
        map: {}
      },
      selectedData: [],
      infoIsShow: false
    }
  },
  methods: {
    handleUpdate (param) {
      let url = 'analyse/bankinfo/getBankInfo/' + param.row.id
      this.G(url).then(data => {
        param.row.bankRates = data.bankRates
        this.$refs.bankinfoInfoRef.openModel('update', param.row)
      })
    },
    handleDetail (param) {
      let url = 'analyse/bankinfo/getBankInfo/' + param.row.id
      this.G(url).then(data => {
        param.row.bankRates = data.bankRates
        this.$refs.bankinfoInfoRef.openModel('detail', param.row)
      })
    },
    handleCreate () {
      this.$refs.bankinfoInfoRef.openModel('create')
    },
    handleDelete () {
      this.D('analyse/bankinfo', getIds(this.selectedData)).then(data => {
        this.$Message.success(data)
        this.handleSearch()
      })
    },
    selectionChange (selection) {
      this.selectedData = selection
    },
    handleSearch (page, pageSize) {
      if (isNaN(page)) {
        page = 1
      }
      let param = {
        page: page,
        pageSize: pageSize,
        model: this.form,
        map: this.form.map
      }
      this.L('analyse/bankinfo', param).then(data => {
        this.tableData = data
      })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>
